const INF = 1000000000;

export const createEnumComparer = <T extends string>(enumOrder: T[]) => {
  return (a: T, b: T) => {
    const aPosition = (enumOrder.indexOf(a) === -1) ? INF : enumOrder.indexOf(a);
    const bPosition = (enumOrder.indexOf(b) === -1) ? INF : enumOrder.indexOf(b);

    return aPosition - bPosition;
  };
};